export const seoData = {
    title: {
        fr: "Projet SENSEI",
        en: "SENSEI Project"
    },
    desc: {
        fr: "La banquise est un écosystème d'une très grande diversité. Or depuis plusieurs années, elle ne cesse de diminuer. Le projet SENSEI cherche à comprendre quelles sont et quelles seront les conséquences sur les espèces qui y vivent, y chassent et s'y reproduisent ?",
        en: "TODO La banquise est un écosystème d'une très grande diversité. Or depuis plusieurs années, elle ne cesse de diminuer. Le projet SENSEI cherche à comprendre quelles sont et quelles seront les conséquences sur les espèces qui y vivent, y chassent et s'y reproduisent ?",
    },
};